module.exports = __webpack_public_path__ + "static/img/mk3.9db26a87.svg";